import { PNL_STATEMENT_LINE_DIMENSION } from 'src/components/star-grid/starGridConstants';
import { PnlQueryResponse } from 'src/components/star-grid/starGridTypes';

const PRESENTATION_FIELDS = new Set(['label', 'scaling', 'variance_sign']);

export const hasPnlDisplayMetadata = (response?: PnlQueryResponse): boolean =>
  Boolean(response?.columns.some((column) => column.kind === 'display' && column.name === 'scaling'));

export const needsPnlDisplayMetadata = (response: PnlQueryResponse): boolean =>
  !response.axis &&
  response.rows.length > 0 &&
  response.columns.some((column) => column.name === PNL_STATEMENT_LINE_DIMENSION) &&
  !hasPnlDisplayMetadata(response);

/** Copy only statement presentation metadata; historical values and order always win. */
export const withPnlDisplayMetadata = (response: PnlQueryResponse, reference: PnlQueryResponse): PnlQueryResponse => {
  const columns = reference.columns.filter((column) => column.kind === 'display' && PRESENTATION_FIELDS.has(column.name));
  const byStatement = new Map(
    reference.rows.map((row) => [row[PNL_STATEMENT_LINE_DIMENSION], Object.fromEntries(columns.map((column) => [column.name, row[column.name]]))])
  );
  const existing = new Set(response.columns.map((column) => column.name));
  return {
    ...response,
    columns: [...response.columns, ...columns.filter((column) => !existing.has(column.name))],
    rows: response.rows.map((row) => ({ ...byStatement.get(row[PNL_STATEMENT_LINE_DIMENSION]), ...row }))
  };
};
